import { TennisResultsCategoriesProps } from "@sky-it-livedata/livedata-sports-design-system";
import { loggerFactory } from "@sky-it-livedata-libraries/livedata-commons";

import errors from "../../utils/errors";

import { ResultsCategoriesData } from "./types";
import {
  cagetoriesMapGranSlam,
  categoriesMap,
} from "../../utils/categoriesMap";

const logger = loggerFactory();

const isValidObject = (obj: ResultsCategoriesData) =>
  Boolean(obj?.data?.getResultsCategoriesWidget);

type Categories = TennisResultsCategoriesProps["categories"];
type Adv = TennisResultsCategoriesProps["adv"];

export const transformQuery = (
  obj: ResultsCategoriesData
): TennisResultsCategoriesProps => {
  if (isValidObject(obj)) {
    try {
      const widget = obj?.data?.getResultsCategoriesWidget!;
      const categories = (widget?.categories || []) as Categories;
      const { link, image } = widget?.adv || {};
      return {
        adv: link ? ({ link, image } as Adv) : undefined,
        targetSelector: "ld-tennis-results",
        categories: categories?.map((category) => ({
          ...category,
          name: category.name,
          label: getCategoryName(category.name, widget.tournamentType),
        })),
        initialIndex: 0,
        setDefaultIndex: () => {},
      };
    } catch (error) {
      logger.error("ERROR 5001: transform() error in Results Categories transformer", obj);
      throw errors.fromCode(5001);
    }
  } else {
    logger.error("ERROR 5000", obj);
    throw errors.fromCode(5000);
  }
};

function getCategoryName(name: string, tournamentType?: string) {
  if (tournamentType === "GrandSlam") {
    return (
      cagetoriesMapGranSlam[name as keyof typeof cagetoriesMapGranSlam] || name
    );
  }
  return categoriesMap[name as keyof typeof categoriesMap] || name;
}
